import React from 'react';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';

import { pmsDetailTabs } from '../../constants';

export default function DetailLayout({
  children,
  activeTab = pmsDetailTabs.BASIC_INFO,
  handleSetActiveTab,
}) {
  const { t } = useTranslation();

  return (
    <div className="layout-wrapper">
      <Menu
        onSelect={handleSetActiveTab}
        style={{ width: 248 }}
        defaultSelectedKeys={[activeTab]}
        mode="inline"
      >
        <For of={Object.keys(pmsDetailTabs)} each="tab" index="index">
          <Menu.Item key={pmsDetailTabs[tab]}>
            {t(`cms.landlord.detail.${tab.toLowerCase()}.tab`)}
          </Menu.Item>
        </For>
      </Menu>
      <div className="layout-children">{children}</div>
    </div>
  );
}
